<template>
  <transition name="fade" mode="out-in">
    <component :is="layout" />
  </transition>
</template>

<script>

import GlobalLoading from './layouts/GlobalLoading.vue'
import LoginLayout from './layouts/LoginLayout.vue'
import MainLayout from './layouts/MainLayout.vue'
import '@fontsource/roboto/100.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/900.css';
import '@fontsource/roboto';

export default {
  name: 'App',

  data: () => ({
    //
  }),
  computed:{
    layout() {
      if (this.$store.getters.globalLoading) {
        return 'GlobalLoading'
      } else if (this.$store.getters.token) {
        return 'MainLayout'
      } else {
        return 'LoginLayout'
      }
    }
  },
  async mounted(){
    await this.$store.dispatch('loadLocale')
    
    try {
      await this.$store.dispatch('tryLogin')
    } catch (e) {
      await this.$store.commit('setGlobalLoading')
      console.error('Error on app mount: ', e)
    }
    
  },
  components:{
    GlobalLoading,
    LoginLayout,
    MainLayout
  }
};
</script>

<style>
/* ===== Scrollbar CSS ===== */
  /* Firefox */
  * {
    scrollbar-width: auto;
    scrollbar-color: #4caf50 #ffffff;
  }

  /* Chrome, Edge, and Safari */
  *::-webkit-scrollbar {
    width: 12px;
  }

  *::-webkit-scrollbar-track {
    background: #ffffff;
  }

  *::-webkit-scrollbar-thumb {
    background-color: #8faf9065;
    border-radius: 12px;
    border: 2px solid #ffffff;
  }

/* ===== pages fade animation =====  */

.fade-enter-active {
  transition: all 0.1s ease;
  opacity: 0;
  transform: scale(.99);
}

.fade-enter-to {
  opacity: 1;
  transform: scale(1);;
}

.fade-leave-active {
  transition: all 0.1s ease;
  opacity: 1;
  transform: scale(1);
}

.fade-leave-to {
  opacity: 0;
  transform: scale(.99);
}

body {
  font-family: "Roboto", sans-serif !important;
  font-weight: 400;
}

</style>
